export default __webpack_public_path__ + "static/6_15-7bb77f74fa4c6eac2be09d4b75770b93.png";